// extracted by mini-css-extract-plugin
export default {"optionIcon":"hQsxl3gBX6hjLJFeubSF","triangle":"LCXtTOvVC3ubcqfO4obe","noTriangle":"SC05PsEsZreCf3EIlSpy","optionWrapper":"un17haJnFKU_s1PDSWRY"};